import { Box2, Vector2 } from "three";
import { DOMHitTest } from "../../dom-tools/DOMHitTest";
import { OnMouseDown, OnMouseMove, OnMouseUp } from "../../dom-tools/EventListeners";
import { ButtonInfo } from "../basics/ButtonInfo";
import { PointerInfo } from "../basics/PointerInfo";


/*
  Needs updates from external input processors:

  Mouse Position: 
    mouse.nextPosition

  Mouse Buttons:
    mouse.buttons[ index ].setNext
  


*/
export class UIInteractionEvent
{
  consumed:boolean = false;
  pageOffset:Vector2 = new Vector2();
  bounds:Box2 = new Box2( new Vector2( 0, 0 ), new Vector2( 1, 1 ) );
  size:Vector2 = new Vector2( 1, 1 );

  mouse:PointerInfo = PointerInfo.createMouseInfo()
  touches:PointerInfo[] = [];
  ctrlKey = new ButtonInfo();
  altKey = new ButtonInfo();
  shiftKey = new ButtonInfo();
  keys = new Map<string,ButtonInfo>();
  _changedKeys:ButtonInfo[] = [];
  _pressedKeys:Set<ButtonInfo> = new Set<ButtonInfo>();

  get localMousePosition():Vector2
  {
    return this.mouse.position.clone().sub( this.pageOffset );
  }

  setMouseListeners( element:HTMLElement )
  {
    OnMouseMove.add( element, e =>
      { 
        this.mouse.positionNext = DOMHitTest.getPointerPosition( e ); 
      } 
    );

    OnMouseDown.add( element, e => 
      {
        this.mouse.buttons[ e.button ].setNext( true );
      }
    );

    OnMouseUp.add( element, e => 
      {
        this.mouse.buttons[ e.button ].setNext( false );
      }
    );
  }

  get hoveredElement():Element
  {
    let position = this.mouse.position;

    return document.elementFromPoint( position.x, position.y );
  }

  setKey( id:string, state:boolean )
  {
    if ( ! this.keys.has( id ) )
    {
      this.keys.set( id, ButtonInfo.create( id ) );
    }

    let key = this.keys.get( id );
    key.setNext( state );
    this._changedKeys.push( key );

    if ( state )
    {
      this._pressedKeys.add( key );
    }
    else
    {
      this._pressedKeys.delete( key );
    }
  }

  reset()
  {
    this.consumed = false;
  }

  update()
  {
    this.reset();

    this.pageOffset.copy( this.bounds.min );
    this.bounds.getSize( this.size );

    this._changedKeys.forEach( b => b.update() );
    this._changedKeys = [];

    this.ctrlKey.update();
    this.shiftKey.update();
    this.altKey.update();
    
    this.mouse.update();
  }

}